/* Brand House: switcher behavior, persistence, and brand catalog filtering.
   Brand priority on load: product's own brand > localStorage > 'zenmen'
   (the pre-paint script in theme.liquid decides; this keeps it).
   State lives in localStorage only — switching never changes the URL.
   Persistence is EXPLICIT-ONLY: a stored preference is written on a switcher
   click, never from merely landing on a branded page. */
(function () {
  var KEY = 'pp_house_brand';

  function current() {
    return document.documentElement.getAttribute('data-brand') || 'zenmen';
  }

  function switchTo(next) {
    var prev = current();
    if (!next || next === prev) return;
    /* Persist first so whatever loads next reads the new brand, then open that
       brand's homepage front door. Each brand's homepage is its own page (the
       Precise one is templates/index.precise.json, reached as /?view=precise),
       so a switch always navigates, on the homepage too. The default homepage
       always opens as Zenmen (see the pre-paint script in theme.liquid), so
       the URL has to say which brand to open. */
    persist(next);
    apply(next);
    var home = (window.ZPTheme && ZPTheme.root) || '/';
    var homeFor = next === 'precise' ? home + (home.indexOf('?') > -1 ? '&' : '?') + 'view=precise&brand=precise' : home;
    window.location.assign(homeFor);
  }

  function persist(brand) {
    try {
      localStorage.setItem(KEY, brand);
    } catch (e) {
      /* storage unavailable */
    }
  }

  /* Fonts for both brands load once from theme.liquid's combined link;
     this script no longer injects any font requests. */

  /* Products tagged brand:precise / brand:zenmen only show in their own brand view.
     Products with no brand tag show in both. Hiding uses a class (styled in
     brand-house.css) rather than inline styles so it composes with Dawn CSS,
     and is re-applied whenever Dawn re-renders a grid (facets, pagination,
     search, quick-add) via the MutationObserver installed in init(). */
  var allBrands = false;
  function filterCatalog(brand) {
    document.querySelectorAll('[data-brand-tags]').forEach(function (el) {
      if (allBrands) {
        (el.closest('.grid__item') || el).classList.remove('brand-hide-item');
        return;
      }
      var tags = (el.getAttribute('data-brand-tags') || '').toLowerCase();
      var isPrecise = tags.indexOf('brand:precise') > -1;
      var isZenmen = tags.indexOf('brand:zenmen') > -1;
      var hide = (isPrecise || isZenmen) && !(brand === 'precise' ? isPrecise : isZenmen);
      var item = el.closest('.grid__item') || el;
      item.classList.toggle('brand-hide-item', hide);
    });
  }

  var refilterTimer = null;
  function scheduleRefilter() {
    if (refilterTimer) return;
    refilterTimer = setTimeout(function () {
      refilterTimer = null;
      filterCatalog(current());
    }, 60);
  }

  function apply(brand) {
    document.documentElement.setAttribute('data-brand', brand);
    filterCatalog(brand);
    document.querySelectorAll('.brand-bar__tab').forEach(function (btn) {
      var on = btn.getAttribute('data-brand-target') === brand;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var favicon = document.getElementById('site-favicon');
    if (favicon) {
      var url = favicon.getAttribute(brand === 'zenmen' ? 'data-zen-favicon' : 'data-precise-favicon');
      if (url && url !== favicon.getAttribute('href')) {
        favicon.setAttribute('href', url);
        favicon.setAttribute('type', /\.svg(\?|$)/.test(url) ? 'image/svg+xml' : 'image/png');
      }
    }
  }

  /* "Find my formula" panel: a disclosure under the selector bar. Escape or a
     click outside closes it and returns focus to its button. */
  function initFinder() {
    var btn = document.querySelector('[data-brand-find]');
    var panel = document.querySelector('[data-brand-panel]');
    if (!btn || !panel) return;
    function set(open, refocus) {
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open && refocus) btn.focus();
    }
    btn.addEventListener('click', function () {
      set(panel.hidden);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) set(false, true);
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !panel.contains(e.target) && !btn.contains(e.target)) set(false);
    });
  }

  function init() {
    /* The pre-paint script already settled the brand (a product page uses
       the product's own brand); a stored preference is only written on an
       explicit switcher click. */
    apply(current());

    document.querySelectorAll('.brand-bar__tab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        switchTo(btn.getAttribute('data-brand-target'));
      });
    });
    initFinder();

    /* Cart "Continue shopping" returns to the home of the brand last shopped
       (plan ticket 03). Delegated, because the drawer re-renders its links. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-brand-home]');
      if (a) a.href = current() === 'precise' ? '/?view=precise&brand=precise' : '/?brand=zenmen';
    });

    /* Search scope: this brand (default) or all brands. */
    document.querySelectorAll('[data-brand-scope]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        allBrands = btn.getAttribute('data-brand-scope') === 'all';
        document.querySelectorAll('[data-brand-scope]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        filterCatalog(current());
      });
    });

    /* Re-filter after Dawn re-renders product grids (facets/pagination/search
       replace DOM nodes, which would otherwise resurface the other brand). */
    if (typeof MutationObserver !== 'undefined' && document.body) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && (n.hasAttribute && n.hasAttribute('data-brand-tags') || (n.querySelector && n.querySelector('[data-brand-tags]')))) {
              scheduleRefilter();
              return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', scheduleRefilter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
